import { useQuery } from 'react-query';
import request from '../../../../helpers/request';

const key = (streetId) => ['house-filter', streetId];

const getHouse = async (streetId) => {
  return await request.get(
    `/Filter/houses/${streetId}`,
    {},
    'При получении списка домов произошла ошибка'
  );
};

const useHouseQuery = (streetId, options = {}) =>
  useQuery(key(streetId), () => getHouse(streetId), options);

export default useHouseQuery;
